export default __webpack_public_path__ + "static/nav-7a00a8d9314431f6307ebed8d94bcb99.png";